import React, { Fragment } from "react";
import Link from "gatsby-link";
import styled from "styled-components";
import baseStyles from "../styles/baseStyles";

const Wrapper = styled.footer`
  background: ${baseStyles.color.blueGradient};
  margin-top: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 64rem;
  width: 100%;
  padding: 3rem 0;
  @media screen and (max-width: 64em) {
    padding: 3rem 2rem;
    flex-wrap: wrap;
    justify-content: center;
  }
`;

const CategoryTitle = styled(Link)`
  color: rgba(255, 255, 255, 0.9);
  font-family: Futura;
  font-size: 22px;
  font-weight: 500;
  letter-spacing: 1.1px;
  line-height: 30px;
  text-decoration: none;
  text-transform: uppercase;
`;

const CategoryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media screen and (max-width: 64em) {
    width: 45%;
    margin-bottom: 2rem;
  }
  @media screen and (max-width: 375px) {
    width: 100%;
  }
`;

const SubTitle = styled(Link)`
  color: rgba(255, 255, 255, 0.8);
  font-family: Lato;
  font-size: 16px;
  letter-spacing: 1.2px;
  line-height: 19px;
  text-decoration: none;
  font-weight: 400;
  margin: 0.25rem 0;
`;

const renderCategories = (aboutMenu, eventTypes, jobRoles) => {
  const menuItems = [
    {
      name: "Nordics",
      slug: "/nordics",
      items: [
        {
          name: "Overview",
          slug: "/nordics/overview"
        },
        {
          name: "Sweden",
          slug: "/nordics/sweden"
        },
        {
          name: "Norway",
          slug: "/nordics/norway"
        },
        {
          name: "Iceland",
          slug: "/nordics/iceland"
        },
        {
          name: "Finland",
          slug: "/nordics/finland"
        },
        {
          name: "Denmark",
          slug: "/nordics/denmark"
        }
      ]
    },
    {
      name: "Jobs",
      slug: "/jobs",
      items: jobRoles
    },
    {
      name: "Events",
      slug: "/events",
      items: eventTypes
    },
    {
      name: "About",
      slug: "/about",
      items: aboutMenu
    }
  ];

  return menuItems.map(({ name, slug, items }) => {
    const renderItems =
      items &&
      items.map(subItem => (
        <SubTitle key={subItem.name} to={subItem.slug}>
          {subItem.name}
        </SubTitle>
      ));
    return (
      <CategoryWrapper key={name}>
        <CategoryTitle to={slug}>{name}</CategoryTitle>
        {renderItems}
      </CategoryWrapper>
    );
  });
};

const Footer = ({ aboutMenu, eventTypes, jobRoles }) => {
  return (
    <Wrapper>
      <Container>{renderCategories(aboutMenu, eventTypes, jobRoles)}</Container>
    </Wrapper>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js